import { last, isNil } from 'ramda';

import { displayOverlay, hideOverlay, setLoaderText } from "./uiLoader.shared";

const textUpdateDelayMs = 200;

let statusStack = [];

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const hasActiveStatus = () => statusStack.length > 0;
const currentStatus = () => last(statusStack);

const updateText = () => {
    if (hasActiveStatus()) {
        setLoaderText(currentStatus());
    }
};

// debounce updates to text
const scheduleTextUpdate =
    () => wait(textUpdateDelayMs).then(updateText);

const nextStatus = (specifiedStatus) => {
    if (!isNil(specifiedStatus)) {
        return specifiedStatus;
    }
    if (hasActiveStatus()) {
        return currentStatus();
    }

    return '';
};

const pushStatus = async ({ delay = 0, status = null } = {}) => {
    statusStack.push(nextStatus(status));

    if (statusStack.length === 1) {
        await wait(delay);

        if (hasActiveStatus()){
            displayOverlay();
        }
    }

    scheduleTextUpdate();
};


const popStatus = () => {
    statusStack.pop();

    if (hasActiveStatus()) {
        scheduleTextUpdate();
    } else {
        hideOverlay();
    }
};


export {
    pushStatus,
    popStatus,
};